import { v4 as uuid4 } from 'uuid';
import { Point, Line, Polygon } from '../../../context/context';

/**
 * Process KML file content and extract shapes (points, lines, polygons)
 */
export function processKMLContent(kmlContent: string): (Point | Line | Polygon)[] {
    const shapes: (Point | Line | Polygon)[] = [];
    const parser = new DOMParser();
    const xml = parser.parseFromString(kmlContent, 'text/xml');
    const placemarks = Array.from(xml.getElementsByTagName('Placemark'));
    
    placemarks.forEach(pm => {
        const name = pm.getElementsByTagName('name')[0]?.textContent || '';
        
        // Process Point
        const point = pm.getElementsByTagName('Point')[0];
        if (point) {
            const coords = point.getElementsByTagName('coordinates')[0]?.textContent?.trim();
            if (coords) {
                const [lon, lat] = coords.split(',').map(Number);
                shapes.push({
                    id: uuid4(),
                    type: 'point',
                    name,
                    description: '',
                    colour: '#3388ff',
                    icon: 'default',
                    size: 24,
                    isLocked: false,
                    coordinates: [lat, lon],
                } as Point);
            }
        }
        
        // Process LineString
        const line = pm.getElementsByTagName('LineString')[0];
        if (line) {
            const coords = line.getElementsByTagName('coordinates')[0]?.textContent?.trim();
            if (coords) {
                const points = coords.split(/\s+/).map(pair => {
                    const [lon, lat] = pair.split(',').map(Number);
                    return [lat, lon] as [number, number];
                });
                shapes.push({
                    id: uuid4(),
                    type: 'line',
                    name,
                    description: '',
                    colour: '#3388ff',
                    opacity: '1',
                    borderColour: '#3388ff',
                    borderWidth: 2,
                    isLocked: false,
                    coordinates: points,
                    arrowStyle: 'arrow',
                } as Line);
            }
        }
        
        // Process Polygon
        const polygon = pm.getElementsByTagName('Polygon')[0];
        if (polygon) {
            const coords = polygon.getElementsByTagName('coordinates')[0]?.textContent?.trim();
            if (coords) {
                const points = coords.split(/\s+/).map(pair => {
                    const [lon, lat] = pair.split(',').map(Number);
                    return [lat, lon] as [number, number];
                });
                shapes.push({
                    id: uuid4(),
                    type: 'polygon',
                    name,
                    description: '',
                    colour: '#3388ff',
                    opacity: '0.5',
                    borderColour: '#3388ff',
                    borderWidth: 2,
                    isLocked: false,
                    coordinates: [points],
                } as Polygon);
            }
        }
    });
    
    return shapes;
} 